import Service from "../../Service";
import Axios from "../../Config/API";
import { IStatusEscritura } from "../../../Interfaces/Cobranca/StatusEscritura/StatusEscrituraInterfaces";

export async function ListarTodosStatusEscrituraService() {
    return Service(
        Axios.get<Array<IStatusEscritura>>(
            `/cobranca/statusescritura/listastatusescritura`
        )
    );
}

export async function SalvarStatusEscrituraVendaService(
    idCaso: number,
    lstStatusEscritura: Array<IStatusEscritura>
) {
    return Service(
        Axios.put(
            `/cobranca/statusescritura/salvarstatusescriturauau?idCaso=${idCaso}`,
            lstStatusEscritura
        )
    );
}
